class SearchApi {
  private responseSettings = {
    method: "POST",
  };
  private currentAbortController: AbortController | null = null;

  private async makeRequest(url: string, value: string) {
    if (this.currentAbortController) {
      this.currentAbortController.abort();
    }

    this.currentAbortController = new AbortController();
    const signal = this.currentAbortController.signal;

    try {
      const response = await fetch(`${url}/${value}`, { ...this.responseSettings, signal });
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      return response;
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Previous request aborted');
      } else {
        console.error("An error occurred:", error);
        throw error; // Propagate the error for handling at a higher level if needed
      }
    }
  }

  // Performs a generic search
  async search(value: string, fullSearch: boolean) {
    return await this.makeRequest("/search", value + '/full:' + (fullSearch ? 1 : 0));
  }

  // Performs a search for herbs
  async searchHerbs(value: string) {
    return await this.makeRequest("/search-herbs", value);
  }
}

export const searchApi = new SearchApi();

export type searchData = {
  html: string; // rerendered search-dropdown-item.twig
  success: boolean;
  requestFullSearch: boolean;
  datalayerPush: string;
};
